import enumerable from './enumerable';

export default (group, values) =>
  values.map(({ value }) => ({
    value,
    label: enumerable(group, value)
  }));
